import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchEducatorContactList } from "../actions/contact";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender } from "../utils/cellRenderTable";
import { createDateColumn } from "../utils/agGridDateColumn";

const EducatorContactList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { educatorContactList } = useSelector((state) => state.contactReducer);
    console.log(educatorContactList,"contact list");
  //breadcrumb
  const translateModule = "educatorContact";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchEducatorContactList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    // if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/educator-contact-edit/` + params.data.id}
        // deleteItemId={params.data.id}
        // deleteItemTitle={`${params.data.firstName} ${params.data.lastName}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    // dispatch(deleteUser(pageId));
  };

  const columnDefs = [
    {
      headerName: "Ime i prezime",
      field: "fullName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Email adresa",
      field: "email",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
      {
      headerName: "Oblast rada",
      field: "workType",
      filter: "agTextColumnFilter",
    },
     {
      headerName: "Naslov",
      field: "title",
      filter: "agTextColumnFilter",
    },
    // {
    //   headerName: "Tekst poruke",//za sada ne dobijamo od sa backa, proveri zasto
    //   field: "message",
    //   filter: "agTextColumnFilter",
    // },
    createDateColumn("Datum kreiranja", "createdAt"),
    // {
    //   headerName: "Aktivan",
    //   field: "active",
    //   filter: "agSetColumnFilter",
    //   cellRenderer: statusRender,
    //   maxWidth: 180,
    //   valueGetter: (params) => {
    //     if (params.data?.active === true) return "Aktivan";
    //     if (params.data?.active === false) return "Neaktivan";
    //     return "";
    //   },
    // },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchEducatorContactList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={educatorContactList}
        columnDefs={columnDefs}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="educator-contact-list"
      />
    </Fragment>
  );
};

export default EducatorContactList;
